import {DetailsInformationObservedField} from '@/components/commons/details-information-observed-field/DetailsInformationObservedField'
import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {Text} from '@/components/ui/text/Text'
import {PatientExtended, PatientVademecumFormValidationSchema} from '@/features/patients/types'
import {useTranslation} from '@/translations/i18n'
import {z} from 'zod'

type PatientVademecumFormValidationKey = keyof z.infer<typeof PatientVademecumFormValidationSchema>

export const PatientVademecumDetails = ({patient}: {patient: PatientExtended}) => {
    const {t} = useTranslation()

    return (
        <DetailsField>
            <Text palette="neutral" shade="500" size="textSm">
                Vademecum
            </Text>
            <DetailsInformationObservedField<PatientVademecumFormValidationKey>
                name="vademecum"
                value={patient.vademecum && t('commons:signed')}
            />
        </DetailsField>
    )
}
